define('flight-components/SideDrawer',[
  'flight/lib/component'
],

function(defineComponent) {

  var uiOffCanvasNav = function uiOffCanvasNav() {

    var defaults;

    defaults = {
      toggleSelector: '[data-action="toggleOffCanvasNav"]',
      pageWrapSelector: '.wrapper',
      isShowing: false,
      wrapperSlideSpeed: 270,
      wrapperEasing: 'easeOutExpo',
      navWidth: '270px'
    };
    this.defaultAttrs(defaults);

    this.handleToggleAction = function(ev) {
      if (!this.attr.isShowing) {
        this.showNav();
      } else {
        this.hideNav();
      }
      this.attr.isShowing = !this.attr.isShowing;
    };

    this.showNav = function() {
      var self = this;
      var $wrapper = $(this.attr.pageWrapSelector);
      var $logo = $('.secondary-logo');
      var winHeight = this.attr.winHeight || window.innerHeight;
      var winWidth = this.attr.winWidth || window.innerHeight;

      // freeze the body element in place, set to window height and hide overflow
      $('body').anima({
        height: winHeight,
        overflow: 'hidden'
      });

      // prepare the offscreen nav container for slide in animation
      this.$node.anima({
        left: 0,
        x: '-' + this.attr.navWidth,
        height: winHeight,
        width: this.attr.navWidth
      });

      // slide out the main page
      $wrapper.anima({
        x: this.attr.navWidth
      }, this.attr.wrapperSlideSpeed, this.attr.wrapperEasing);

      // slide in the nav container
      this.$node.anima({
        x: 0
      }, this.attr.wrapperSlideSpeed, this.attr.wrapperEasing, {
        complete: function() {
          self.$node.addClass('off-canvas-nav--active');
        }
      });

    };

    this.hideNav = function() {
      var self = this;
      var $wrapper = $(this.attr.pageWrapSelector);

      // slide back the page wrapper
      $wrapper.anima({x: 0},
        this.attr.wrapperSlideSpeed,
        this.attr.wrapperEasing,
        {
          complete: function() {
            $('body').anima({
              height: '100%',
              overflow: 'visible'
            });
            self.$node.removeClass('off-canvas-nav--active');
          }
        }
      );

      // slide out the nav container
      this.$node.anima({
        x: '-' + this.attr.navWidth
      }, this.attr.wrapperSlideSpeed, this.attr.wrapperEasing);

    };


    /**
     *  Refresh the screen dimensions and reposition elements
     */
    this.updateDimensions = function(ev, data) {
      this.attr.winHeight = data.height;
      this.attr.winWidth = data.width;

      if (this.attr.isShowing) {
        this.showNav();
      }
    };


    this.after('initialize', function(){
      var self = this;

      // listen for resize events and update the elements
      this.on(document, 'uiViewportResized', this.updateDimensions);

      // listen for touch/click events on the nav toggle element
      $(self.attr.toggleSelector)
          .on('click', function(ev) {
            ev.preventDefault();
            self.handleToggleAction(ev);
          });
    });
  };
  return defineComponent(uiOffCanvasNav);
});

